import { DownloadSecurityContainerView } from '../view/DownloadSecurityContainerView';
import { templateDownloadSecurityContainer } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { DownloadSecurityContainerWebComponent } from '../component/DownloadSecurityContainerWebComponent';
import { DownloadSecurityContainerRepository } from '../repository/DownloadSecurityContainerRepository';
import { DownloadSecurityContainerWindowData } from '../types/download-security-container-data';

export class DownloadSecurityContainerController extends BaseWebComponentController {
  public component: DownloadSecurityContainerWebComponent;
  public view: DownloadSecurityContainerView;
  public viewConstructor: typeof DownloadSecurityContainerView;
  public dataRepository: DownloadSecurityContainerRepository;
  public dataRepositoryConstructor: typeof DownloadSecurityContainerRepository;

  constructor(component: DownloadSecurityContainerWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: DownloadSecurityContainerView,
      viewTemplate: templateDownloadSecurityContainer,
      dataRepositoryConstructor: DownloadSecurityContainerRepository,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$closeButton,
        event: 'click',
        callback: this.closeDownloadSecurityContainer,
      },
      {
        element: this.view.dom.$cancelButton,
        event: 'click',
        callback: this.closeDownloadSecurityContainer,
      },
    ];
  }

  public async getDataForView(): Promise<DownloadSecurityContainerWindowData> {
    if (this.component.getUseNewDataRepository()) {
      return await this.dataRepository.getDownloadSecurityContainerLinks(this.component.getPackageId());
    }
    return await this.dataRepository.getDownloadSecurityContainerData();
  }

  private closeDownloadSecurityContainer() {
    this.dependencies.CloseDownloadSecurityContainerWindow();
  }
}
